
const EnviromentConfig = {
  API_URL: process.env.REACT_APP_API_URL || "http://localhost:8080",
  //API_URL: process.env.REACT_APP_API_URL || "https://cosepav.ipsistemas.com.ar/",

};

export default EnviromentConfig;
